<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form
            ref="formData"
            label-width="180px"
            size="mini"
        >
            <div class="top">
                <div style="font-weight: 900;">下载模板</div>
                <div>
                    <a href="/export/SP每日广告活动报告模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载SP每日广告活动报告模板</a>
                </div>
            </div>
            <div class="download">
                <el-upload
                    class="upload-demo"
                    drag
                    action="/"
                    accept=".xls, .xlsx"
                    ref="upload"
                    :file-list="files"
                    :http-request="handleUpload"
                    :on-exceed="handExceed"
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    :limit="1"
                    multiple
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                    </div>
                    <div
                        class="el-upload__text"
                        style="font-size: 12px;margin-top: 5px;"
                    >
                        只能上传.xls/.xlsx文件
                    </div>
                </el-upload>
            </div>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/statistics/statistics";
export default {
    data() {
        return {
            files: [],
            dateArr: [],
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },

        state: String,
        asin: Number
    },
    methods: {
        handleUpload(raw) {
            this.files.push(raw.file);
        },
        handExceed(files, fileList) {
            this.$message({
                type: "warning",
                message: `当前限制选择 1 个文件，共选择了 ${files.length +
                    fileList.length} 个文件.`
            });
            return;
        },
        handFileSuccess() {
            this.files = [];
            this.$refs.upload.clearFiles();
        },
        handleRemove(file, fileList) {
            this.files = fileList;
        },
        // 保存信息
        submitForm() {
            this.$refs.upload.submit(); // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
            if (this.files.length == 0) {
                this.$message.warning(`当前限制只能上传选择 1 个文件`);
                return;
            }
            let file = new FormData();
            console.log('file111:', this.files[0])
            file.append("file", this.files[0]);
            file.append("state", this.$route.query.state);
            file.append("asin", this.$route.query.asin);
            const loading = this.$loading({
                lock: true,
                text: "上传中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            api.budget_control_upload(file)
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "上传成功",
                            type: "success"
                        });
                        this.disabled = false;
                        this.handleClose(true);
                    } else {
                        this.disabled = false;
                        this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                })
                .finally(() => {
                    loading.close();
                });
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.handFileSuccess();
            this.$refs["formData"].resetFields();
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
